module.exports = __webpack_public_path__ + "media/phiphi/phiphi_nests-29d037eb.jpg";